import { useState, useEffect } from 'react';
import { variables } from '@domain-group/fe-brary';
import { useMediaQuery } from 'beautiful-react-hooks';

// TODO: Deprecate this hook, as it causes issues with server-side rendering (mismatch)
// Ignoring in coverage because it is just an existing hook with our def of a mobile size
/* istanbul ignore next */
const useIsDesktop = (): boolean => {
  const { desktopMinWidth } = variables.global;
  const isDesktopMedia = useMediaQuery(`(min-width: ${desktopMinWidth})`);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  // Only return media query result after hydration, otherwise default to false (mobile)
  return hydrated ? isDesktopMedia : false;
};

export default useIsDesktop;
